module.exports = __webpack_public_path__ + "05_veryshort_beige.6f512c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_veryshort_beige.png
// module id = HnWs
// module chunks = 0